import gql from 'graphql-tag';

const GET_CUSTOMER = gql`
  query getCustomers(
    $filter: CustomerFilterInput
    $sort: CustomerSortInput
    $skip: Int
    $take: Int
  ) {
    getCustomers(filter: $filter, sort: $sort, skip: $skip, take: $take) {
      customers {
        id
        name
        identifier
        devicesCount
        customerCategory {
          id
          description
        }
        phoneNumbers
        email
        workspaceId
        image
        labels {
          id
          name
          color
          type
        }
        street
        city
        state
        countryId
        zipCode
      }
      aggregate {
        rows
      }
    }
  }
`;

const GET_CUSTOMER_BY_ID = gql`
  query GetCustomerById($customerId: ID!) {
    getCustomerById(id: $customerId) {
      id
      name
      identifier
      customerCategory {
        id
        description
      }
      phoneNumbers
      email
      workspaceId
      image
      labels {
        id
        name
        color
        type
      }
      street
      city
      state
      countryId
      zipCode
    }
  }
`;

const GET_CUSTOMERS_BY_WORKSPACE = gql`
  query GetCustomersByWorkspace(
    $workspaceId: ID!
    $filter: CustomerFilterInput
    $sort: CustomerSortInput
    $skip: Int
    $take: Int
  ) {
    getCustomersByWorkspace(
      workspaceId: $workspaceId
      filter: $filter
      sort: $sort
      skip: $skip
      take: $take
    ) {
      customers {
        id
        name
        identifier
        devicesCount
        customerCategory {
          id
          description
        }
        phoneNumbers
        email
        workspaceId
        image
        labels {
          id
          name
          color
          type
        }
        street
        city
        state
        countryId
        zipCode
      }
      aggregate {
        rows
      }
    }
  }
`;

export default {
  GET_CUSTOMER,
  GET_CUSTOMER_BY_ID,
  GET_CUSTOMERS_BY_WORKSPACE,
};
